export function onlineOrderFlowInit(){
    function setAddressForm(address1: any, address2: any, city: any, state: any, zipcode: any){
        $('#service-address-screen [name="address"]').val(address1);
        $('#service-address-screen [name="address2"]').val(address2);
        $('#service-address-screen [name="city"]').val(city);
        $('#service-address-screen option[value='+state+']').attr('selected','selected');
        $('#service-address-screen input[name="zipcode"]').val(zipcode);
        $("#service-address-screen .next").removeClass("disble-btn").prop("disabled", false);
    }
    $(document).on("click", "#personal-next", function (){
        if($('.Address2os').val()=='')
        $('.address2Label').addClass('label-active');
        var addresses = JSON.parse(localStorage.getItem("address")) as any[];
        if (addresses){
            var address1Obj = addresses.find(form => form.name === 'Address1');
            var address2Obj = addresses.find(form => form.name === 'Address2');
            var cityObj = addresses.find(form => form.name === 'City');
            var stateObj = addresses.find(form => form.name === 'state');
            var zipcodeObj = addresses.find(form => form.name === 'zipcode');
            setAddressForm(address1Obj.value, address2Obj.value, cityObj.value, stateObj.value, zipcodeObj.value);
            if(address2Obj.value){
                $("#addressmodal-os input#Address2").next('label').removeClass('label-active');
            }
        }
        if (!$('.service-address-form #Zip-Code').val()){
            let zipcode = localStorage.getItem("zipcode");
            if(zipcode) {
            zipcode = zipcode.replace(/"/g, "");
            }
            $('.service-address-form #Zip-Code').val(zipcode);
        }
    });
}